import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService } from '../service/companies.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.css']
})
export class CompaniesListComponent implements OnInit, OnDestroy {

  search;
  status = "active";
  portal = 'nemt'
  companiesList = [];
  user;
  timeZone;
  todayDate;
  canView = false;

  constructor(private companiesService: CompaniesService, private sharedDataService: SharedDataService) {
    document.addEventListener('keyup', e => {
        console.log(e);
        // e.ctrlKey &&
        if (e.altKey && (e.key.toLowerCase() === 'v' || e.key.toLowerCase() === '√')) {
          this.canView = !this.canView;
        }
      });
   }

  ngOnInit() {

    this.sharedDataService
    .getUser()
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.timeZone = this.user.timeZone;
        this.todayDate = moment().tz(this.timeZone);
        this.companiesListData();
      }
    });

  }


  companiesListData() {
    this.companiesService.getCompaniesList(this.status)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.companiesList = data;
          this.companiesList.sort((a, b) => <any>new Date(b.created) - <any>new Date(a.created));
          // this.companiesList.forEach(company => {
          //   company.focalPerson = "";
          //   company.focalPersonNumber = ""
          // });
         }
      },);
  }




  onChangeStatus() {
    this.companiesListData()
  }

  onChangePlatform(){

  }
  getTrialStatus(date) {
    const trialEndDate = moment(date).tz(this.timeZone);
    return trialEndDate.diff(this.todayDate, 'days');
  }

  openProviderPanel(companyId) {
    this.companiesService.getCompanyToken(companyId)
    .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data: any) => {
          window.open(`${environment.PROVIDER_URL}auth-token/${data.companyToken}`, '_self');
      });
  }

  ngOnDestroy(): void {
  }
}
